// Loyalty fields use server revisions; unrelated historical settings retain their existing payload.
const aliases = new Set(['fidWheelPrizes', 'fidScratchPrizes', 'fidLoyaltyRewards']);
const shared = key => /^(fid|loyalty)[A-Z]/.test(key) && key !== 'loyaltyRevision';
const customerColors = new Set(['uiPrimaryColor', 'uiAccentColor', 'uiBackgroundColor', 'uiTextColor']);
const kioskExperienceFields = new Set(['kioskExperience', 'kioskExperienceConfig']);
export function adminSettingsPatch(current, baseline) {
  const body = Object.fromEntries(Object.entries(current).filter(([key]) => !shared(key) && key !== 'loyaltyRevision' && key !== 'customerAppearanceRevision' && !customerColors.has(key) && !kioskExperienceFields.has(key)));
  const experienceChanged = [...kioskExperienceFields].some(key => current[key] !== undefined && JSON.stringify(current[key]) !== JSON.stringify(baseline?.[key]));
  if (experienceChanged) {
    body.kioskExperience = current.kioskExperience || 'default';
    body.kioskExperienceConfig = current.kioskExperienceConfig || {};
  }
  const changedColors = Object.entries(current).filter(([key, value]) => customerColors.has(key) && value !== undefined && value !== baseline?.[key]);
  if (changedColors.length) {
    if (typeof baseline?.customerAppearanceRevision !== 'string' || !/^[a-f0-9]{64}$/.test(baseline.customerAppearanceRevision)) {
      throw new Error('La version de la palette ne peut pas être vérifiée. Actualisez les réglages avant de modifier les couleurs.');
    }
    Object.assign(body, Object.fromEntries(changedColors), { customerAppearanceRevision: baseline.customerAppearanceRevision });
  }
  const revisions = {};
  for (const [key, value] of Object.entries(current)) {
    if (!shared(key) || aliases.has(key) || value === undefined || JSON.stringify(value) === JSON.stringify(baseline?.[key])) continue;
    body[key] = value;
    if (baseline?.loyaltyRevision?.[key]) revisions[key] = baseline.loyaltyRevision[key];
  }
  return { ...body, loyaltyRevision: revisions };
}
export function campaignAttempt(previous, content, uuid = () => crypto.randomUUID()) {
  const serialized = JSON.stringify(content);
  return previous?.content === serialized ? previous : { content: serialized, id: uuid() };
}
export function campaignComplete(result) {
  return result?.status === 'completed' && Number(result.totalPending) === 0 && Number(result.totalUncertain) === 0;
}
